// Contrato de línea: Cantidad describe siempre las unidades reales que se pagan.
(() => {
  if (window.MPLineQuantity) return;
  const root = () => window.Shopify?.routes?.root || '/';
  const headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
  const managed = new Set(['Cantidad', '_cajas', '_piezas', '_m2_solicitados', '_ml_solicitados', '_merma_pct', '_ajuste_cliente']);
  const metadata = new Map(), aliases = new Map(), attempts = new Set();
  const nativeFetch = window.fetch.bind(window);
  let queue = Promise.resolve(), pending = 0, blocked = false, scheduled = false, reloaded = false, initialized = false;
  const number = (value, fixed = false) => new Intl.NumberFormat('es-ES', {
    useGrouping: false, minimumFractionDigits: fixed ? 2 : 0, maximumFractionDigits: 2,
  }).format(value);
  const config = info => ({
    mode: info.mode || (Number(info.m2) > 0 || info.unitType === 'm2' ? 'm2' : 'ml'),
    unitSize: Number(info.unitSize ?? (Number(info.m2) > 0 ? info.m2 : info.ml)) || (info.unitType === 'm2' ? 1 : 0),
    boxSize: Math.max(1, Number(info.boxSize) || 1),
    unitType: info.unitType || (info.unitPlural === 'm²' ? 'm2' : info.unitPlural === 'm de rollo' ? 'roll-meter' : 'box'),
  });
  const boxed = info => info && (config(info).mode === 'm2' && config(info).unitSize > 0 || config(info).mode === 'ml' && config(info).boxSize > 1);
  const label = (qty, info) => {
    const { mode, unitSize, boxSize, unitType } = config(info);
    if (!boxed(info)) return '';
    if (mode === 'm2' && unitType === 'm2') return `${number(qty)} m²`;
    if (mode === 'm2' && unitType === 'roll-meter') return `${number(qty)} m de rollo · ${number(qty * unitSize, true)} m²`;
    if (mode === 'm2' && unitType === 'roll') return `${number(qty)} rollo${qty === 1 ? '' : 's'} · ${number(qty * unitSize, true)} m²`;
    if (mode === 'm2' && unitType === 'pack') return `${number(qty)} pack${qty === 1 ? '' : 's'} A+B (${number(qty * 2)} cajas) · ${number(qty * unitSize, true)} m²`;
    const boxes = mode === 'm2' ? qty : qty / boxSize;
    const boxText = `${number(boxes)} caja${boxes === 1 ? '' : 's'}`;
    return mode === 'm2' ? `${boxText} · ${number(qty * unitSize, true)} m²`
      : `${boxText} · ${qty} tira${qty === 1 ? '' : 's'}${unitSize > 0 ? ` · ${number(qty * unitSize)} ml` : ''}`;
  };
  const properties = (props, qty, info, discard = false) => {
    const result = { ...props }, { mode, boxSize } = config(info);
    if (!boxed(info)) return result;
    // Reparar propiedades nunca descarta la petición original, aunque falte _cajas.
    // Solo una cantidad cambiada explícitamente por el cliente autoriza descartarla.
    if (discard) {
      delete result._m2_solicitados; delete result._ml_solicitados; delete result._merma_pct;
    }
    result._cajas = String(mode === 'm2' ? qty : qty / boxSize);
    if (mode === 'ml') result._piezas = String(qty);
    else delete result._piezas;
    result.Cantidad = label(qty, info);
    return result;
  };
  const stable = props => JSON.stringify(Object.entries(props || {}).filter(([, v]) => v !== '' && v != null).sort(([a], [b]) => a.localeCompare(b)));
  const identity = item => JSON.stringify([String(item.variant_id || item.id), item.selling_plan_allocation?.selling_plan?.id || item.selling_plan || null,
    stable(Object.fromEntries(Object.entries(item.properties || {}).filter(([key]) => !managed.has(key))))]);
  const variantTotal = (item, items) => items.filter(line => String(line.variant_id || line.id) === String(item.variant_id || item.id)).reduce((sum, line) => sum + line.quantity, 0);
  const collect = (doc = document) => {
    const items = [];
    doc.querySelectorAll('script[data-mp-quantity-data]').forEach(script => {
      const data = JSON.parse(script.textContent);
      data.forEach(item => { metadata.set(String(item.variant_id), item); items.push(item); });
    });
    return items;
  };
  const infoFor = item => metadata.get(String(item.variant_id || item.id));
  const incomplete = (item, items) => {
    const info = infoFor(item);
    if (!boxed(info)) return false;
    const size = config(info).mode === 'ml' ? config(info).boxSize : 1;
    const total = variantTotal(item, items);
    return total < size || total % size !== 0;
  };
  const stale = (item, discard = false) => boxed(infoFor(item)) && stable(properties(item.properties, item.quantity, infoFor(item), discard)) !== stable(item.properties);
  const needsRepair = items => items.some(item => incomplete(item, items) || stale(item));
  const setBlocked = value => {
    blocked = value;
    document.documentElement.classList.toggle('mp-quantity-blocked', blocked || pending > 0);
  };
  const read = async () => {
    const response = await nativeFetch(`${root()}cart.js`, { cache: 'no-store', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('cart.js');
    return response.json();
  };
  const loadMetadata = async cart => {
    collect();
    if (cart.items.every(item => infoFor(item))) return;
    const response = await nativeFetch(`${root()}?sections=mp-quantity-data`, { cache: 'no-store' });
    if (!response.ok) throw new Error('Metadatos de cajas');
    const html = (await response.json())['mp-quantity-data'];
    if (typeof html !== 'string') throw new Error('Metadatos de cajas');
    collect(new DOMParser().parseFromString(html, 'text/html'));
    if (cart.items.some(item => !infoFor(item))) throw new Error('Faltan metadatos de cajas');
  };
  const write = async (route, body) => {
    const response = await nativeFetch(`${root()}cart/${route}.js`, { method: 'POST', headers, body: JSON.stringify(body) });
    if (!response.ok) throw new Error(`cart/${route}.js`);
    return response.json();
  };
  // No se fusionan líneas: Shopify puede separar precios, descuentos y regalos.
  // Tras cada escritura se comprueba el total de variante y se usan las claves nuevas.
  const reconcile = async (initial, sections = {}, discardKeys = new Set()) => {
    let cart = initial, changed = false;
    await loadMetadata(cart);
    const max = cart.items.length * 3 + 4;
    for (let attempt = 0; attempt < max; attempt++) {
      const item = cart.items.find(item => incomplete(item, cart.items) && item.final_price !== 0 && !item.properties?._mp_regalo_qs)
        || cart.items.find(item => incomplete(item, cart.items))
        || cart.items.find(item => stale(item, discardKeys.has(item.key)));
      if (!item) return { cart, changed };
      const info = infoFor(item), size = config(info).mode === 'ml' ? config(info).boxSize : 1;
      const total = variantTotal(item, cart.items);
      const delta = Math.max(1, Math.ceil(total / size)) * size - total;
      const qty = item.quantity + delta;
      const props = properties(item.properties, qty, info, discardKeys.has(item.key));
      const before = cart;
      cart = await write('change', { ...sections, id: item.key, quantity: qty, properties: props });
      if (variantTotal(item, cart.items) !== total + delta
        || !cart.items.some(line => identity(line) === identity(item) && stable(line.properties) === stable(props))) {
        throw new Error('Cantidad no confirmada');
      }
      discardKeys.delete(item.key);
      remember(before, cart); changed = true;
    }
    throw new Error('No se ha podido normalizar el carrito');
  };
  const remember = (before, after) => before.items.forEach(item => {
    if (after.items.some(line => line.key === item.key)) return;
    const candidates = after.items.filter(line => identity(line) === identity(item) && !before.items.some(old => old.key === line.key));
    if (candidates.length === 1) aliases.set(item.key, candidates[0].key);
  });
  const explicitChanges = (before, after, route, body) => {
    const keys = new Set();
    before.items.forEach((item, index) => {
      const requested = route === 'change'
        ? (body.line ? Number(body.line) === index + 1 : body.id === item.key || String(body.id) === String(item.variant_id)) ? body.quantity : undefined
        : Array.isArray(body.updates) ? body.updates[index] : body.updates?.[item.key] ?? body.updates?.[item.variant_id];
      if (requested == null || Number(requested) === item.quantity) return;
      const targetIdentity = identity({ ...item, properties: route === 'change' && body.properties ? body.properties : item.properties });
      const updated = after.items.find(line => line.key === item.key)
        || after.items.find(line => identity(line) === targetIdentity && !before.items.some(old => old.key === line.key));
      if (updated && updated.quantity !== item.quantity) keys.add(updated.key);
    });
    return keys;
  };
  const resolveKey = key => {
    const visited = new Set();
    while (aliases.has(String(key)) && !visited.has(String(key))) { visited.add(String(key)); key = aliases.get(String(key)); }
    return key;
  };
  const enqueue = operation => {
    pending++; setBlocked(blocked);
    const result = queue.then(operation);
    queue = result.catch(() => {});
    return result.catch(error => { setBlocked(false); notice(); throw error; })
      .finally(() => { pending--; setBlocked(blocked); });
  };
  const bodyOf = async (input, init) => {
    const body = init?.body ?? (typeof input === 'object' && input.clone
      ? (/multipart\/form-data|application\/x-www-form-urlencoded/.test(input.headers.get('Content-Type') || '') ? await input.clone().formData() : await input.clone().text()) : null);
    const contentType = new Headers(init?.headers || (typeof input === 'object' ? input.headers : undefined)).get('Content-Type') || '';
    const fields = typeof body === 'string' && /application\/x-www-form-urlencoded/.test(contentType) ? new URLSearchParams(body) : body;
    if (fields instanceof FormData || fields instanceof URLSearchParams) {
      const result = {};
      for (const [key, value] of fields.entries()) {
        const parts = [key.split('[')[0], ...[...key.matchAll(/\[([^\]]*)\]/g)].map(match => match[1])];
        if (parts.some(part => ['__proto__', 'constructor', 'prototype'].includes(part))) continue;
        let target = result;
        parts.forEach((part, index) => {
          const name = part === '' && Array.isArray(target) ? target.length : part;
          if (index === parts.length - 1) target[name] = value;
          else {
            target[name] ??= parts[index + 1] === '' || /^\d+$/.test(parts[index + 1]) ? [] : {};
            target = target[name];
          }
        });
      }
      return result;
    }
    return body ? JSON.parse(body) : {};
  };
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : input?.url || String(input);
    const parsed = new URL(url, window.location.href);
    const route = parsed.origin === window.location.origin && parsed.pathname.match(/\/cart\/(add|change|update|clear)(?:\.js)?$/)?.[1];
    if (!route || (init?.method || input?.method || 'GET').toUpperCase() === 'GET') return nativeFetch(input, init);
    return enqueue(async () => {
      const body = await bodyOf(input, init);
      const sections = Object.fromEntries(['sections', 'sections_url'].filter(key => body[key] != null).map(key => [key, body[key]]));
      if (body.id && route === 'change') body.id = resolveKey(body.id);
      if (body.updates && !Array.isArray(body.updates)) body.updates = Object.fromEntries(Object.entries(body.updates).map(([key, qty]) => [resolveKey(key), qty]));
      const before = (route === 'change' && body.quantity != null || route === 'update' && body.updates) ? await read() : null;
      const requestHeaders = new Headers(typeof input === 'object' ? input.headers : undefined);
      new Headers(init?.headers).forEach((value, key) => requestHeaders.set(key, value));
      requestHeaders.set('Content-Type', 'application/json');
      const response = await nativeFetch(input, route === 'add' || route === 'clear' ? init
        : { ...init, method: init?.method || input?.method || 'POST', headers: requestHeaders, body: JSON.stringify(body) });
      if (!response.ok) { setBlocked(false); return response; }
      const value = await response.clone().json();
      const cart = route === 'add' ? await read() : value;
      if (before) remember(before, cart);
      const result = await reconcile(cart, sections, before ? explicitChanges(before, cart, route, body) : new Set());
      setBlocked(false);
      remember(cart, result.cart);
      if (!result.changed) return response;
      // add.js debe seguir devolviendo líneas añadidas; change/update devuelven el carrito completo.
      const json = route === 'add' ? { ...value, sections: result.cart.sections || value.sections } : result.cart;
      if (route === 'add') {
        const added = value.items || [value];
        const actual = added.map(item => result.cart.items.find(line => line.key === resolveKey(item.key)) || item);
        if (value.items) json.items = actual;
        else Object.assign(json, actual[0]);
      }
      return new Response(JSON.stringify(json), { status: response.status, headers: response.headers });
    });
  };
  const notice = () => window.MPBoxes?.notice?.('No se ha podido comprobar la cantidad real. Revisa el carrito antes de continuar.');
  const schedule = () => {
    if (initialized || scheduled || document.readyState === 'loading') return;
    scheduled = true;
    try {
      if (needsRepair([...new Map(collect().map(item => [item.key, item])).values()])) setBlocked(true);
    } catch (error) { setBlocked(true); }
    setTimeout(async () => {
      scheduled = false; initialized = true;
      if (pending) return;
      try {
        const items = collect();
        // Página y cajón repiten el mismo estado; deduplicar ANTES de detectar líneas partidas.
        const unique = [...new Map(items.map(item => [item.key, item])).values()];
        if (!needsRepair(unique)) {
          setBlocked(false);
          attempts.clear();
          try { sessionStorage.removeItem('mp-quantity-attempt'); } catch (error) {}
          return;
        }
        setBlocked(true);
        const token = stable(Object.fromEntries(unique.map(item => [item.key, `${item.quantity}:${stable(item.properties)}`])));
        try {
          const previous = JSON.parse(sessionStorage.getItem('mp-quantity-attempt') || 'null');
          if (previous?.confirmed === true) attempts.add(previous.token);
        } catch (error) {}
        if (attempts.has(token)) { setBlocked(false); return; }
        const result = await enqueue(async () => {
          const sections = [];
          document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));
          for (let retry = 0; retry < 2; retry++) {
            try {
              const result = await reconcile(await read(), { sections: [...new Set(sections)].join(',') });
              // Solo una reparación confirmada impide repetir el lote tras recargar HTML antiguo.
              attempts.add(token);
              try { sessionStorage.setItem('mp-quantity-attempt', JSON.stringify({ token, confirmed: true })); } catch (error) {}
              setBlocked(false);
              return result;
            } catch (error) { if (retry === 1) throw error; }
          }
        });
        if (!result.changed) return;
        if (window.themeVariables?.settings?.pageType === 'cart') {
          if (!reloaded) { reloaded = true; window.location.reload(); }
        } else document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'line-item:change', cart: result.cart } }));
      } catch (error) { setBlocked(false); notice(); }
    }, 0);
  };
  const guard = event => {
    const target = event.type === 'submit' ? (event.submitter ? (event.submitter.matches('[name="checkout"]') ? event.submitter : null) : event.target.querySelector('[name="checkout"]'))
      : event.target.closest('[name="checkout"], a[href*="/checkout"], .additional-checkout-buttons');
    if (target && (blocked || pending)) {
      event.preventDefault(); event.stopImmediatePropagation(); notice();
    }
  };
  document.addEventListener('click', guard, true);
  document.addEventListener('submit', guard, true);
  document.addEventListener('DOMContentLoaded', schedule, { once: true });
  window.MPLineQuantity = { label, properties, identity, reconcile, schedule, config, boxed };
  schedule();
})();
